'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.siteHeader = twentyninetimes.siteHeader || function () {

    var doc = document.documentElement;
    var w = window;

    var prevScroll = w.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;

    var header = document.getElementById('js-site-header');
    if(header) {
      var header_height = header.clientHeight;
    }

    function init() {
        if ( header ) {
           toggleHeader(header);
        }
    }

    function checkScroll() {
      /*
      ** Find the direction of scroll
      ** 0 - initial, 1 - up, 2 - down
      */
     
     curScroll = w.scrollY || doc.scrollTop;

      // ( curScroll > header_height ) 
      //   ? header.classList.add('scrolled')
      //   : header.classList.remove('scrolled');

      if (curScroll > prevScroll) { 
        //scrolled up
        direction = 2;
      }
      else if (curScroll < prevScroll) { 
        //scrolled down
        direction = 1;
      }

      if (direction !== prevDirection) {
        toggleHeader(direction, curScroll);

        if(direction == 1) {
          header.classList.add('scroll-up');
          header.classList.remove('scroll-down');
        } else if(direction == 2 && curScroll > header_height) {
          header.classList.add('scroll-down');
          header.classList.remove('scroll-up');
        }
      }

      prevScroll = curScroll;
    }

    function toggleHeader(direction, curScroll) {

        
      if (direction === 2 && curScroll > header_height) { 

        doc.classList.add('hide');
        prevDirection = direction;
      }
      else if (direction === 1) {
        doc.classList.remove('hide');
        prevDirection = direction;
      }
    };

    return {
        init : init,
        checkScroll : checkScroll
    };

}();